function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 9,
  transform: "translate(-6 -6)",
  fill: "#90D984",
  fillRule: "evenodd"
});

var SvgLow = function SvgLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default SvgLow;